import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import UpsellModal from '~/Common-Objects/UpsellModal'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import NumberFunctions from '~/Classes/numberFormatFunctions'
import helpers from '~/Classes/helpers'
import * as siteMaster from '~/data/actions/siteActions'
import axios from '~/data/http/axios'
import Stats from './stats'
import Topup from './topup'
import DrawerAddCampaignStep1 from '~/pages/cp/campaigns/add/drawerAddCampaignStep1'

import DrawerAddCustomField from '~/pages/cp/subscribers/customfields/incAddCustomField.jsx'
import LowCreditsSettings from './low'
import SmsUpgrade from '../../includes/upgrade/sms'
import SmsWelcome from './welcome'
import CreateAutomationModal from '../../includes/automations/createAutomationModal'

export default function SmsSetup() {
    const [account, setAccount] = useState(null)
    const [showAutoTopupSettings, setShowAutoTopupSettings] = useState(false)
    const [showTopup, setShowTopup] = useState(false)
    const [showAddCustomField, setShowCustomField] = useState(false)
    const [errors, setErrors] = useState({})
    const [alert, setAlert] = useState('')
    const [customFields, setCustomFields] = useState([])

    const [validSubscribers, setValidSubscribers] = useState(null)
    const [loading, setLoading] = useState(false)
    const [sendsThisMonth, setSendsThisMonth] = useState(null)
    const [loadingSends, setLoadingSends] = useState(false)
    const [clicksThisMonth, setClicksThisMonth] = useState(null)
    const [loadingClicks, setLoadingClicks] = useState(false)
    const [smsPlan, setSmsPlan] = useState(null)

    const dispatch = useDispatch()
    const history = useHistory()
    const user = useSelector((state) => state.user)

    const getCustomFields = async () => {
        const res = await axios.get('/customfield')
        setCustomFields(
            res.data.CustomFields.filter((c) => c.fieldType === 'TELNO').map((cf) => ({
                label: cf.fieldDesc,
                value: cf.id,
                fieldType: cf.fieldType
            }))
        )
    }
    const getAccount = async () => {
        const res = await axios.get('/accountMaster')
        setAccount(res.data.AccountMaster)
        // setShowAutoTopupSettings(false)
        setShowTopup(false)
    }

    const updateOptions = (e) => {
        const options = account.options ? { ...account.options } : {}
        if (e.currentTarget.type === 'checkbox') {
            options[e.currentTarget.name] = e.currentTarget.checked
        } else {
            // check if the value is a number
            if (e.currentTarget.type === 'number') {
                options[e.currentTarget.name] = Number(e.currentTarget.value)
            } else {
                options[e.currentTarget.name] = e.currentTarget.value
            }
        }
        setAccount({ ...account, options })
    }

    const saveAccount = async () => {
        const errors = {}
        if (account.options && account.options.smsDefaultFromName) {
            const subjectChecker = helpers.smsIsValidSubject(options.smsDefaultFromName)
            if (subjectChecker.messages.length) {
                errors.smsDefaultFromName = subjectChecker.messages.join(', ')
            } else {
                const res = await axios.get('/campaign/checksms?content=' + options.smsDefaultFromName)
                if (res.data.length) {
                    errors.smsDefaultFromName = `From Name cannot contain ${res.data.map((d) => `"${d}"`).join(' or ')}. `
                }
            }
        }
        setErrors(errors)
        if (!Object.keys(errors).length) {
            try {
                await axios.put('/accountMaster', account)
                setAlert('Changes Saved')
            } catch (e) {
                console.log(e)
                setAlert(e.data?.error || 'Something went wrong')
            }
        }
    }

    const createCampaign = () => {
        const drawerContent = <DrawerAddCampaignStep1 selectSms={6} history={history} />
        dispatch(siteMaster.alterSiteDrawer(true, false, 'left', drawerContent, true, 500, 'drawer_nopad'))
    }

    const countSubs = async () => {
        setLoading(true)
        const res = await axios.get('/accountMaster/sms/subscribers?field=-1')
        setValidSubscribers(res.data.count)
        setLoading(false)
    }

    const countSends = async () => {
        setLoadingSends(true)
        const res = await axios.get('/accountMaster/sms/sends')
        setSendsThisMonth(res.data.count)
        setLoadingSends(false)
    }

    const countClicks = async () => {
        setLoadingClicks(true)
        const res = await axios.get('/accountMaster/sms/clicks')
        setClicksThisMonth(res.data.count)
        setLoadingClicks(false)
    }

    const upgrade = () => {
        if (smsPlan.maxUniqueSends === 0) {
            // they are on a legacy PAYG so show the upsell instead
            axios.get('/accountMaster/plan?type=2').then((res) => {
                const modal = (
                    <UpsellModal
                        inline={true}
                        plans={res.data.Plans}
                        feature={'sms'}
                        onUpgrade={() => {
                            dispatch(siteMaster.alterFullpage(null))
                        }}
                    />
                )
                dispatch(siteMaster.alterFullpage(modal))
            })
        } else {
            const content = (
                <SmsUpgrade
                    onFinish={() => {
                        getAccount()
                        dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null))
                    }}
                />
            )
            dispatch(siteMaster.alterSiteDrawer(true, true, 'right', content, true, 500, null, null, true))
        }
    }

    const getUsage = async () => {
        try {
            const res = await axios.get('/accountMaster/usage')
            setSmsPlan(res.data.SmsPlan)
        } catch (e) {
            console.error('Error fetching usage:', e)
        }
    }

    useEffect(() => {
        countSubs()
        countSends()
        countClicks()
        getCustomFields()
        getAccount()
        getUsage()
    }, [])

    if (!account) return <LoadingIcons iconType='2' />

    const remainingCredits = account.smsCredits || 0
    const options = account.options || {}
    const hasPhoneField = customFields.some((cf) => cf.fieldType == 'TELNO')

    if (!account.SmsAccountBillingId) {
        return <SmsWelcome refresh={getAccount} />
    }

    if (!smsPlan) return <LoadingIcons iconType='2' />

    return (
        <Row>
            <Column xs={12} md={4}>
                <Paper style={{ padding: 23 }}>
                    <div className='text-left mar-b20 text-heavy'>Available SMS Credits</div>
                    <div
                        className='quickFlex'
                        style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'baseline' }}
                    >
                        <div className='mar-b15 text-heavy text-left' style={{ fontSize: 40 }}>
                            {NumberFunctions.formatNumber(remainingCredits)}
                        </div>
                        <Button
                            className='button-sml secondary mar-r5'
                            text='Upgrade'
                            iconLeft={<Icons icon='upgradeChevrons' style={{ height: 16, width: 16 }} />}
                            onClick={() => upgrade(true)}
                        />
                    </div>
                </Paper>
            </Column>
            <Column
                xs={12}
                md={8}
                style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', padding: 0 }}
            >
                <Column xs={12} md={4}>
                    <Paper style={{ padding: 23 }}>
                        <div
                            className={'mar-b15 text-center text-heavy ' + (loadingSends ? 'loading' : '')}
                            style={{ fontSize: 40 }}
                        >
                            {loadingSends ? 'Loading' : sendsThisMonth}
                        </div>
                        <div className='text-sml text-heavy text-center '>Messages Sent</div>
                        <div className='text-sml text-grey text-center '>Last 30 Days</div>
                    </Paper>
                </Column>
                <Column xs={12} md={4}>
                    <Paper style={{ padding: 23 }}>
                        <div
                            className={'mar-b15 text-center text-heavy ' + (loadingClicks ? 'loading' : '')}
                            style={{ fontSize: 40 }}
                        >
                            {loadingClicks ? 'Loading' : clicksThisMonth}
                        </div>
                        <div className='text-sml text-heavy text-center '>Links Clicked</div>
                        <div className='text-sml text-grey text-center '>Last 30 Days</div>
                    </Paper>
                </Column>
                <Column xs={12} md={4}>
                    <Paper style={{ padding: 23 }}>
                        <div
                            className={'mar-b15 text-center text-heavy' + (loading ? 'loading' : '')}
                            style={{ fontSize: 40 }}
                        >
                            {loading ? 'Loading' : validSubscribers}
                        </div>
                        <div className='text-sml text-heavy text-center '>SMS Contacts</div>
                        <div className='text-grey text-center' style={{ fontSize: 13 }}>
                            Containing valid phone numbers
                        </div>
                    </Paper>
                </Column>
            </Column>

            <Column xs={12} md={4} lg={4}>
                <Row>
                    <Column xs={12}>
                        <Paper>
                            <h4 className='mar-b25'>Defaults</h4>

                            <TextInput
                                outerClassName='mar-b25'
                                explainer='Must be 3-11 characters long and have no spaces'
                                label='Default From Name'
                                value={options.smsDefaultFromName}
                                name='smsDefaultFromName'
                                placeholder='Your Company Name'
                                onChange={updateOptions}
                                error={errors.smsDefaultFromName}
                            />
                            {hasPhoneField && (
                                <Select
                                    explainer='The default custom field when creating a campaign'
                                    outerClassName='mar-b25'
                                    placeholder='--Select Field--'
                                    label='Phone Number Field'
                                    data={customFields}
                                    value={options.smsDefaultField}
                                    name='smsDefaultField'
                                    onChange={updateOptions}
                                />
                            )}
                            {!hasPhoneField && (
                                <WarningHolder>
                                    <div className='text-red mar-b10'>
                                        You must have a "Telephone Number" custom field setup before you can use SMS
                                    </div>
                                    <div>
                                        <Button
                                            className='button-sml red'
                                            text='Setup a Custom Field'
                                            onClick={() => {
                                                setShowCustomField(true)
                                            }}
                                        />
                                    </div>
                                </WarningHolder>
                            )}

                            {hasPhoneField == true && (
                                <Button text='Save Defaults' className='button-primary' onClick={saveAccount} />
                            )}
                        </Paper>
                    </Column>
                </Row>
            </Column>

            <Column xs={12} sm={12} md={8} lg={8}>
                <Stats account={account} />

                <h4 className='mar-b25'>Where to use SMS</h4>

                <Row>
                    <Column xs={12} md={4}>
                        <Paper className='mar-b0 text-center'>
                            <h4 className='text-primary text-center mar-b15'>
                                <div>
                                    <Icons
                                        style={{ borderRadius: '100%', margin: '0 auto', width: 30 }}
                                        className='mar-b5'
                                        icon='lightning'
                                        circle={true}
                                    />
                                </div>
                                Automations
                            </h4>
                            <p>Make things happen based on your contact activity.</p>
                            <p>
                                <Button
                                    text='Create Automation'
                                    className='button-sml secondary'
                                    onClick={() =>
                                        dispatch(
                                            siteMaster.alterFullpage(
                                                <CreateAutomationModal
                                                    onClose={() => dispatch(siteMaster.alterFullpage(null))}
                                                />
                                            )
                                        )
                                    }
                                />
                            </p>
                        </Paper>
                    </Column>
                    <Column xs={12} md={4}>
                        <Paper className='height-100 mar-b0 text-center'>
                            <h4 className='text-primary text-center mar-b15'>
                                <div style={{ borderRadius: '100%', margin: '0 auto', width: 30 }}>
                                    <Icons icon='mobile' className='mar-b5' circle={true} />
                                </div>
                                Campaigns
                            </h4>
                            <p>Create and send SMS campaigns to your contacts en-mass.</p>
                            <p>
                                <Button
                                    text='Create Campaign'
                                    className='button-sml secondary'
                                    onClick={createCampaign}
                                />
                            </p>
                        </Paper>
                    </Column>
                    <Column xs={12} md={4}>
                        <Paper className='height-100 mar-b0 text-center'>
                            <h4 className='text-primary text-center mar-b15'>
                                <div style={{ borderRadius: '100%', margin: '0 auto', width: 30 }}>
                                    <Icons icon='save' className='mar-b5' circle={true} />
                                </div>
                                Transactions
                            </h4>
                            <p>Send one off SMS messages from your website, or other external app.</p>
                            <p>
                                <Button
                                    text='View Documentation'
                                    className='button-sml secondary'
                                    onClick={() => window.open('/apidocs/81', '_blank')}
                                />
                            </p>
                        </Paper>
                    </Column>
                </Row>
            </Column>

            <Drawer
                standalone={true}
                persist={true}
                isOpen={showTopup}
                width={500}
                showClose={true}
                startClose={() => setShowTopup(false)}
            >
                <Topup onClose={getAccount} />
            </Drawer>
            <Drawer
                standalone={true}
                persist={true}
                isOpen={showAddCustomField}
                width={500}
                showClose={true}
                startClose={() => {
                    setShowCustomField(false)
                }}
            >
                <DrawerAddCustomField
                    forceType='TELNO'
                    getCustomFields={() => {
                        setShowCustomField(false)
                        getCustomFields()
                    }}
                />
            </Drawer>

            <SnackBar message={alert} open={!!alert} dismiss={() => setAlert('')} autoclose={true} />
        </Row>
    )
}
